import { RouterProvider } from 'react-router'

import { ConfirmHost, Toasts } from '../shared/components'

import { AppProviders } from './providers'
import { router } from './router'

export function App() {
  return (
    <AppProviders>
      <RouterProvider router={router} />
      <Toasts />
      <ConfirmHost />
    </AppProviders>
  )
}
